import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Demographic from '@/models/Demographic.js'

export const useDemographicStore = defineStore('demographicStore', () => {
  let syncableModel = useSyncableModel(useApiResource('demographics'), {
    className: Demographic.modelName.name,
    paramKey: Demographic.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
